export default __webpack_public_path__ + "static/media/checkedNew.3605773c.svg";